// Thin GA4 event wrapper. gtag is loaded in index.html; every call is
// fire-and-forget and safe when the tag is blocked or absent.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function track(event: string, params: Record<string, unknown> = {}): void {
  try {
    window.gtag?.('event', event, params);
  } catch {
    // analytics must never break the app
  }
}
